import axios from "axios";

// Create a cache object to store token prices and timestamps
const priceCache = {};

async function getDollarValueOfToken(taskData) {
    console.log('14133434');
    
    try {
        if (!taskData?.reward || !taskData?.currencySymbol) {
            throw new Error("Invalid taskData. Ensure reward and currencySymbol are provided.");
        }

        // Mapping currency symbols to API IDs
        const tokenMapping = {
            ETH: "ethereum",
            USDT: "tether",
            Tomi: "tominet",
            USDC: "usd-coin",
            LINK: "chainlink",
            PEPE: "pepe",
            UNI: "uniswap",
            DOP: "data-ownership-protocol",
            WBTC: "wrapped-bitcoin",
        };

        const tokenId = tokenMapping[taskData.currencySymbol];
        if (!tokenId) {
            throw new Error(`Token ID for ${taskData.currencySymbol} not found`);
        }

        // Check if the price is cached and still valid (less than 5 minutes old)
        const cachedPrice = priceCache[tokenId];
        console.log('cachedPrice', tokenId, cachedPrice);
        
        const now = Date.now();

        if (cachedPrice && (now - cachedPrice.timestamp < 10 * 60 * 1000)) {
            // Return the cached value if within 5 minutes
            const dollarValue = taskData.reward * cachedPrice.priceInUSD;
            // console.log('Returning cached value:', dollarValue);
            return dollarValue;
        }

        // Define the API endpoint
        const apiUrl = `https://api.coingecko.com/api/v3/simple/price?ids=${tokenId}&vs_currencies=usd`;

        // Fetch the current price
        // Fetch the current price with API key in the headers
        const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `CG-AMT6oz8K7Qpx7qESamW9hKZu`
            }
        });

        // Extract the price
        const tokenPriceInUSD = response.data[tokenId]?.usd;

        if (!tokenPriceInUSD) {
            throw new Error(`Could not fetch price for ${taskData.currencySymbol}`);
        }

        // Cache the new price and the current timestamp
        priceCache[tokenId] = {
            priceInUSD: tokenPriceInUSD,
            timestamp: now,
        };

        // Calculate the dollar value
        const dollarValue = taskData.reward * tokenPriceInUSD;
        // console.log('Fetched new price and calculated dollar value:', dollarValue);

        return dollarValue;
    } catch (error) {
        console.error("Error fetching token price:", error.message);
        throw error
        return null;
    }
}

export default getDollarValueOfToken;


// import axios from "axios";

// async function getDollarValueOfToken(taskData) {
//     try {
//         if (!taskData?.reward || !taskData?.currencySymbol) {
//             throw new Error("Invalid taskData. Ensure reward and currencySymbol are provided.");
//         }

//         // Mapping currency symbols to API IDs
//         const tokenMapping = {
//             ETH: "ethereum",
//             USDT: "tether",
//             Tomi: "tomi",
//             USDC: "usd-coin",
//             LINK: "chainlink",
//             PEPE: "pepe",
//             UNI: "uniswap",
//             DOP: "dop",
//             WBTC: "wrapped-bitcoin",
//         };

//         const tokenId = tokenMapping[taskData.currencySymbol];
//         if (!tokenId) {
//             throw new Error(`Token ID for ${taskData.currencySymbol} not found`);
//         }

//         // Define the API endpoint
//         const apiUrl = `https://api.coingecko.com/api/v3/simple/price?ids=${tokenId}&vs_currencies=usd`;

//         // Fetch the current price
//         const response = await axios.get(apiUrl);

//         // Extract the price
//         const tokenPriceInUSD = response.data[tokenId]?.usd;

//         if (!tokenPriceInUSD) {
//             throw new Error(`Could not fetch price for ${taskData.currencySymbol}`);
//         }

//         // Calculate the dollar value
//         const dollarValue = taskData.reward * tokenPriceInUSD;
//         console.log(dollarValue, 'dollarValue');
//         return dollarValue
//         return {
//             currency: taskData.currencySymbol,
//             reward: taskData.reward,
//             dollarValue,
//         };
//     } catch (error) {
//         console.error("Error fetching token price:", error.message);
//         return null;
//     }
// }

// export default getDollarValueOfToken;